<template>
  <div class="flex flex-col">
    <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div>
        <form @submit.prevent="fetch()" class="col-12">
          <div class="form-row row text-center">
            <div class="col-11">
              <b-form-input
                type="text"
                name="search"
                id="search"
                v-model="search"
                class="form-control px-2"
                placeholder="Buscar"
                @update="fetch()"
              ></b-form-input>
            </div>
            <div class="col-1">
              <button type="submit" class="btn btn-primary px-2">Buscar</button>
            </div>
          </div>
        </form>

        <div v-if="!loading">
          <table
            class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12"
          >
            <thead class="table-active">
              <tr>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4"
                >
                  Nombre del colaborador
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-3"
                >
                  Número de identificación
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Estado
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Clase de riesgo
                </th>
                <th
                  scope="col"
                  class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Cargo
                </th>
                <th
                  scope="col"
                  class="px-6 text-center text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2"
                >
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="employee in employees" :key="employee.id">
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ employee.full_name }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  <b>{{ employee.identification_number }}</b>
                </td>
                <td class="px-1 mx-2 w-20">
                  <span
                    class="badge float"
                    :class="{
                      'badge-soft-warning': employee.is_active === 2,
                      'badge-soft-danger':
                        getStatus(employee.is_active, employee.contract_end_date) ===
                        false,
                      'badge-soft-success':
                        getStatus(employee.is_active, employee.contract_end_date) ===
                        true,
                    }"
                  >
                    {{
                      getStatus(employee.is_active, employee.contract_end_date)
                        ? "Activo"
                        : "Inactivo"
                    }}
                  </span>
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ getRisk(employee.risk_class) }}
                </td>
                <td class="px-6 text-sm text-gray-500 mx-2">
                  {{ employee.position ? employee.position : "-" }}
                </td>
                <td class="text-center">
                  <div class="col-sm-12">
                    <b-dropdown variant="primary">
                      <template v-slot:button-content>
                        <i class="mdi mdi-eye"></i>
                      </template>
                      <b-dropdown-item
                        :to="{
                          path: `/forms/editar-colaboradores/${employee.id}`,
                        }"
                        >Editar</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <div class="text-center pt-4">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <Pagination
          ref="paginator"
          :search="search"
          @fetch="(items) => (employees = items)"
          @loading="(load) => (loading = load)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "./EmployeePagination";
import { isActive } from "@/utils/helpers/check";

export default {
  components: { Pagination },
  data() {
    return {
      employees: [],
      search: "",
      loading: true,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$refs.paginator.query();
    },

    getStatus(status, date) {
      return isActive(status, date);
    },

    getRisk(risk) {
      if (risk === "UPA") {
        return "UPA";
      } else if (risk === "group_1") {
        return "Clase I";
      } else if (risk === "group_2") {
        return "Clase II";
      } else if (risk === "group_3") {
        return "Clase III";
      } else if (risk === "group_4") {
        return "Clase IV";
      } else {
        return "Clase V";
      }
    },
  },
};
</script>
